const initialState = {
  newOrganizationInstitutionForm: false,
  prisonCode: null,
  prisonNumber: '',
  gender: '',
  orgInstitutionSapList: [],
};
export default initialState;
